import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AlliedservicesService {
  private adminToken: string | null;
  private urlLocal: string =
    environment.apiRoot || 'https://alternadevelop.com/api/v1/';

  private urlProd: string = environment.apiRoot;
  public nameOrganization = new BehaviorSubject<string>('');
  public shareName = this.nameOrganization.asObservable();
  constructor(private http: HttpClient) {}

  //downloadTemplate file
  getLineaBaseFileTemplate() {
    return this.http.get(
      `${this.urlProd}allied/download-template`,
      { responseType: 'blob', context: checkToken() }
    );
  }

  //saveFiles
  uploadImportFile(alliedId: any, file: any, query?: string) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http
      .post(
        `${this.urlProd}allied/linea-base-import?id_allied=${alliedId}`,
        formData,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  getAllAlliedProgressSheet(allied_id: string | null): Observable<Blob> {
    return this.http.get(
      `${this.urlLocal}statistics/generate-all-csv?id_allied=${allied_id}`,
      {
        responseType: 'blob',
        context: checkToken(),
      }
    );
  }

  getAllCompaniesTimeAppSheet(allied_id: string[], start_date: string, end_date: string) {
    const body = {
      allieds_ids: allied_id,
      start_date: start_date,
      end_date: end_date
    };
  
    return this.http.post<Blob>(
      `${this.urlLocal}statistics/generate-app-time`,
      body,
      {
        responseType: 'blob' as 'json',
        context: checkToken(),
      }
    );
  }

  private _refresrequired = new Subject<void>();
  get Refreshrequired() {
    return this._refresrequired;
  }

  private organizationPage: number = 2;
  public loading: boolean = false;

  shareNameOrganization(name: string) {
    this.nameOrganization.next(name);
  }

  getOrganizationScrolling(search: string, page: number, limit: number) {
    if (this.loading) {
      return of([]);
    }
    this.loading = true;
    return this.http
      .get(`${this.urlLocal}allied/list-allied`, {
        params: {
          search,
          page: this.organizationPage,
          limit,
        },
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this.organizationPage++;
          this.loading = false;
        })
      );
  }

  getListOrganizations(search: string, page: number, limit: number) {
    return this.http.get(`${this.urlLocal}allied/list-allied`, {
      params: {
        search,
        page,
        limit,
      },
      context: checkToken(),
    });
  }

  getOrganizationById(idOrg: string) {
    return this.http.get(
      `${this.urlLocal}allied/detail-allied?id_allied=${idOrg}`,
      { context: checkToken() }
    );
  }

  createAllied(data: any) {
    return this.http
      .post(`${this.urlLocal}allied/add-allied`, data, {
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  editAllied(id: string, data: any) {
    return this.http
      .put(`${this.urlLocal}allied/edit-allied/?id_allied=${id}`, data, {
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  //general dashboard dat

  getMainDashboardDataByOrg(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardEnterpriseStatus(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-enterprise-status?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardAverageEmployees(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-average-employees?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardMedian(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-median?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

  getGeneralDashboardMonthlyIncome(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-monthly-income?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardCompaniesFinancing(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-companies-financing?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardImpactStats(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-impact-stats?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardBusinessStagePercent(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-business-stage-percent?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardCompanyRanking(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-company-ranking?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

  //metrics

  dashboardAllData() {
    return this.http.get(`${this.urlLocal}/allied/allied-dashboard`, {
     context: checkToken(),
    });
  }

  dashboardDataByYear(id_allied: string, year: string) {
    return this.http
      .get(
        `${this.urlLocal}/allied/allied-dashboard?id_allied=${id_allied}&year=${year}`,
        {
          context: checkToken(),
        }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }
}
